<template>
  <v-card title="人员维护">
    <div class="grid-demo">
      <v-form slot="form">
        <v-row :gutter="24">
          <v-col class="gutter-row" span="12">
            <div style="text-align: left">
              <v-form-item>
                <v-button type="success" icon="plus" @click="add('')"
                  ><span>添加</span></v-button
                >
              </v-form-item>
            </div>
          </v-col>
          <v-col class="gutter-row" span="12">
            <div style="text-align: right">
              <v-form-item>
                <v-input placeholder="输入姓名" v-model="cx"></v-input>
              </v-form-item>
              <v-form-item>
                <v-button type="primary" icon="search" @click="findList('1')"
                  ><span>检索</span></v-button
                >
              </v-form-item>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </div>
    <br />
    <vxe-grid
      v-bind="xGridOptions"
      size="mini"
      stripe
      highlight-current-row
      highlight-hover-row
      ref="xTable"
      :data="tableData"
      row-id="gh"
    >
      <!-- @sort-change="sortChangeEvent"  @checkbox-change="checkboxChangeEvent"  @checkbox-all="checkboxChangeEvent"-->
      <!--自定义插槽 cz-->
      <template v-slot:cz="{ row }">
        <span>
          <span>
            <a class="link" @click="add(row)" title="修改">
              <v-icon type="edit"></v-icon>
            </a>

            &nbsp;&nbsp;
            <v-popconfirm
              title="确定重置密码?"
              @confirm="reset(row)"
              @cancel="cancel"
              placement="bottomRight"
            >
              <a class="link" title="重置密码">
                <v-icon type="reload"></v-icon>
              </a>
            </v-popconfirm>

            &nbsp;&nbsp;

            <v-popconfirm
              title="是否确认删除数据，删除后数据无法恢复！"
              @confirm="del(row)"
              @cancel="cancel"
              placement="bottomRight"
            >
              <a class="link" title="删除">
                <v-icon type="delete"></v-icon>
              </a>
            </v-popconfirm>
          </span>
        </span>
      </template>
      <template v-slot:empty>
        <span style="color: red">
          <p>未搜索到结果！</p>
        </span>
      </template>
    </vxe-grid>
    <vxe-pager
      :current-page="pagination.pageindex"
      :page-size="pagination.pagesize"
      :total="pagination.totalresult"
      :layouts="[
        'PrevPage',
        'JumpNumber',
        'NextPage',
        'FullJump',
        'Sizes',
        'Total',
      ]"
      @page-change="handlePageChange"
    ></vxe-pager>
  </v-card>
</template>
<script>
let options = {
  id: ""
};
let pagination = {
  sort: "gh",
  sorttype: "desc",
  pagesize: 10,
  pageindex: 1,
  totalresult: 1
};

export default {
  data() {
    return {
      options,
      pagination,
      tableData: [],
      visible: false,
      message: "",
      cx: "",
      xGridOptions: {
        showOverflow: true,
        resizable: true,
        height: document.documentElement.clientHeight - 200,
        headerAlign: "center",
        columns: [
          {
            field: "rn",
            title: "序号",
            width: 70,
            align: "center"
          },

          {
            field: "xm",
            title: "姓名",
            align: "center",
            // sortable: true,
            width: 100
          },
          {
            field: "xb",
            title: "性别",
            align: "center",
            //sortable: true,
            slots: {
              default: ({ row, column }) => {
                let xb = row.xb == 1 ? "男" : "女"
                if (row.xb == 1) {
                  xb = "男"
                } else if (row.xb == 2) {
                  xb = "女"
                } else {
                  xb = row.xb
                }
                return [
                  <span>{xb}</span>
                ];
              }
            }
          },
          {
            field: "zw",
            title: "职位",
            align: "center",
            // sortable: true,
          },
          {
            field: "lxdh",
            title: "联系电话",
            align: "center"
          },
          {
            field: "bmmc",
            title: "部门",
            align: "center",
            //sortable: true,
          },
          {
            field: "yhm",
            title: "用户名",
            align: "center",
            // sortable: true,
          },
          {
            field: "xybz",
            title: "状态",
            align: "center",
            // sortable: true,
            slots: {
              default: ({ row, column }) => {
                let xybz = row.xybz == 1 ? "启用" : "禁用"
                return [
                  <span>{xybz}</span>
                ];
              }
            }
          },
          {
            field: "cz",
            title: "操作",
            align: "center",
            width: 100,
            slots: {
              // 对应自定义插槽的名称
              default: "cz"
            }
          }
        ]
      }
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList(index) {
      if (index == "1") {
        this.pagination.pageindex = 1;
      }
      this.$axios
        .get(
          "api/system/qxgl/get-rywh-list?cx=" + this.cx, { params: this.pagination }
        )
        .then(res => {
          // debugger
          this.tableData = res.data.data
          this.pagination.totalresult = res.data.total;
        });
    },
    add: function (row) {
      let gh = row == "" ? "" : row.gh;
      let title = row == "" ? "添加人员" : "修改人员";
      xadmin.open(title, "/rywhadd?gh=" + gh, "600", "500", "", this.findList);
    },

    reset: function (row) {
      this.$axios
        .get("api/system/qxgl/get-rywh-reset?gh=" + row.gh)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message["success"](res.data.message);
            this.findList();
          } else {
            this.$message["error"](res.data.message);
          }
        });
    },

    handlePageChange({ currentPage, pageSize }) {
      this.pagination.pageindex = currentPage;
      this.pagination.pagesize = pageSize;
      this.findList();
    },
    del: function (row) {
       this.$axios
        .get("api/system/qxgl/del-rywh-list?gh=" + row.gh)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message["success"](res.data.message);
            this.findList();
          } else {
            this.$message["error"](res.data.message);
          }
        });
    },
    cancel: function () {
      this.$message.info("取消删除");
    },
  }
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/view/xtgl/yhgl/rywh.vue